<script setup lang="ts">
import { computed } from 'vue';
import type { Cell, Row } from './types';

const props = defineProps<{
  row: Row;
  cell: Cell;
}>();

const cellType = computed(() => props.cell.column.type || 'text');
const cellValue = computed(() => props.cell.value);

const isBool = computed(() => cellType.value === 'bool');
</script>

<template>
  <td :class="cell.className">
    <ItpIcon v-if="isBool && cellValue" name="fa-check"></ItpIcon>
    <ItpIcon v-if="isBool && cellValue === false" name="fa-times"></ItpIcon>

    <span v-if="!isBool">{{ cellValue }}</span>
  </td>
</template>
